import React from 'react';
import { Box } from '@iclinic/design-system';

import * as S from './SignupBanners.styles';
import { image } from 'shared/utils/urlGetter';
import { BenefitsList } from './BenefitsList';

export function SignupBanners() {
  return (
    <Box overflow="auto" width="100%">
      <S.BannerWrapper>
        <S.CardWrapper>
          <S.BannerCard>
            <img src={image('signup.doctor')} alt="Médica" />
            <S.BannerHeading inverseTextColor variant="xs">
              Teste por <strong>5 dias</strong> as soluções do{' '}
              <strong>melhor sistema para médicos e consultórios</strong>
            </S.BannerHeading>
          </S.BannerCard>
        </S.CardWrapper>
        <BenefitsList />
        <S.CardWrapper>
          <S.DemonstrationCard>
            <img src={image('signup.app')} alt="Médica" />
            <S.BannerHeading inverseTextColor variant="xs">
              Você pode agendar uma <strong>demonstração de 15 minutos</strong>{' '}
              para fazer um tour guiado pelo iClinic
            </S.BannerHeading>
          </S.DemonstrationCard>
        </S.CardWrapper>
      </S.BannerWrapper>
    </Box>
  );
}
